<script lang="ts" setup>
import { computed, defineProps, markRaw, onBeforeUnmount } from 'vue'
import { useLoginStore } from '~/store/login/login'
import { CurrentForm } from '~/store/login/login.types'

import LoginFormRequestCode from '@/components/login/LoginFormRequestCode.vue'
import LoginFormSignIn from '@/components/login/LoginFormSignIn.vue'
import LoginFormConfirmCode from '@/components/login/LoginFormConfirmCode.vue'
import LoginFormSetName from '@/components/login/LoginFormSetName.vue'

const loginComponent = {
  LoginFormRequestCode,
  LoginFormSignIn,
  LoginFormConfirmCode,
  LoginFormSetName,
}

defineProps({
  signInRedirectPath: {
    type: String,
    required: false,
    default: null,
  },
})

const loginStore = useLoginStore()

const currentForm = computed(
  (): CurrentForm => markRaw(loginComponent[loginStore.currentForm]),
)

onBeforeUnmount(() => loginStore.clearState())
</script>

<template>
  <transition name="fade" mode="out-in">
    <component
      :is="currentForm"
      :sign-in-redirect-path="signInRedirectPath"
      v-bind="$attrs"
    />
  </transition>
</template>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.1s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-active {
  opacity: 0;
  transition: all 0.1s;
}
</style>
